import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";

const OdHistory = ({ mid }) => {
    const { callApi: getOdHistoryApi } = useApi("/od/history", "GET");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchHistory = async () => {
        setLoading(true);
        const res = await getOdHistoryApi(null, `?username=${mid}`);
        setData(res?.history || []);
        setLoading(false);
    };

    useEffect(() => {
        if (mid) fetchHistory();
    }, [mid]);

    const typeStyle = {
        DRAW: "bg-blue-100 text-blue-700",
        SETTLE: "bg-green-100 text-green-700",
        PENALTY: "bg-red-100 text-red-700",
    };

    return (
        <div className="bg-white rounded-2xl shadow border mt-5">
            <div className="flex items-center justify-between px-5 py-4 border-b">
                <div className="flex items-center gap-2">
                    <div className="w-1 h-5 bg-amber-500 rounded-full"></div>
                    <h3 className="font-bold text-gray-800 text-sm">OD Transaction History</h3>
                </div>
                <button
                    onClick={fetchHistory}
                    disabled={loading}
                    className="text-xs text-[#0A2A4F] font-semibold hover:underline disabled:opacity-50"
                >
                    {loading ? "Refreshing..." : "Refresh"}
                </button>
            </div>

            {loading ? (
                <div className="flex flex-col items-center gap-3 py-14">
                    <div className="w-8 h-8 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-gray-400 text-sm">Loading OD transactions...</p>
                </div>
            ) : data.length === 0 ? (
                <div className="text-center py-14">
                    <div className="text-4xl mb-3">📭</div>
                    <p className="text-gray-500 text-sm font-medium">No OD transactions found</p>
                </div>
            ) : (
                <div className="overflow-auto max-h-[420px]">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-50 sticky top-0 border-b">
                            <tr>
                                {["Txn ID", "Type", "Amount", "Balance After", "Remarks", "Date", "Status"].map((h) => (
                                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide whitespace-nowrap">
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {data.map((item, i) => (
                                <tr key={i} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-4 py-3 font-mono text-xs text-gray-600">{item.txnId}</td>
                                    <td className="px-4 py-3">
                                        <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${typeStyle[item.txnType] || "bg-gray-100 text-gray-700"}`}>
                                            {item.txnType}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 font-semibold text-gray-800">
                                        ₹ {Number(item.amount).toLocaleString("en-IN")}
                                    </td>
                                    <td className="px-4 py-3 text-gray-700">
                                        ₹ {Number(item.utilizedAfter).toLocaleString("en-IN")}
                                    </td>
                                    <td className="px-4 py-3 text-xs text-gray-500 max-w-[160px] truncate">{item.remarks || "—"}</td>
                                    <td className="px-4 py-3 text-xs text-gray-500 whitespace-nowrap">
                                        {new Date(item.createdAt).toLocaleString("en-IN", {
                                            day: "2-digit", month: "short", year: "numeric",
                                            hour: "2-digit", minute: "2-digit", hour12: true,
                                        })}
                                    </td>
                                    <td className="px-4 py-3">
                                        <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${
                                            item.status === "SUCCESS" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                                        }`}>
                                            {item.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default OdHistory;
